import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {iconClass} from 'src/app/enums/icon-class.enum';
import {GroupedMainRoute} from 'src/app/models/MainRoute';
import {RoutingService} from 'src/app/services/Routing.service';
import {slideInLeftToRightAnimation} from 'src/app/tinea-components/animations/slideInLeftToRight';
import {AuthService} from 'src/app/tinea-components/okta/auth/auth.service';
import {AppGuardType} from 'src/app/tinea-components/okta/enum/AppGuardType';
import {FullyLoggedInStateType} from 'src/app/tinea-components/okta/enum/FullyLoggedInStateType';
import {LoggedInService} from 'src/app/tinea-components/okta/services/loggedIn.service';
import {UserSessionService} from 'src/app/tinea-components/okta/services/session/user-session.service';
import {environment} from 'src/environments/environment';
import {Tooltip} from 'primeng/tooltip';
import {
  QuickAccessPanelComponent
} from 'src/app/modules/left-navigation/quick-access-panel/quick-access-panel.component';
import { NgOptimizedImage } from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: '.app-left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.scss'],
  animations: [slideInLeftToRightAnimation],
  imports: [
    RouterLink,
    Tooltip,
    RouterLinkActive,
    QuickAccessPanelComponent,
    TranslatePipe,
    NgOptimizedImage
]
})
export class LeftNavigationComponent implements OnInit {
  readonly VERSION = environment.VERSION;

  @Input() fullSidebar!: boolean;
  @Output() panelToggle = new EventEmitter<boolean>();
  @Output() autoCollapseChange = new EventEmitter<boolean>();

  userName = '';
  iconClass = iconClass;
  logo = environment.core.logoPath;
  logoInline = environment.core.logoInline;
  groupedRoutes!: GroupedMainRoute[];
  autAppGuard = environment.authAppGuard;
  NotAuthenticatedJustLoggedIn = AppGuardType.NOT_AUTHENTICATED_JUST_LOGGEDIN;
  urlPublicWebsite!: string;
  enableAutoCollapse = false;


  constructor(
    public router: Router,
    public authService: AuthService,
    public loggedInService: LoggedInService,
    private userSessionService: UserSessionService,
    private routingService: RoutingService,
  ) {

  }

  async ngOnInit() {
    this.subscription();
  }

  /*********************** USER START ************************/
  logout() {
    this.authService.logout();
  }

  setMenu() {
    const user = this.userSessionService.getUser();
    this.userName = user.firstName + ' ' + user.lastName;
    this.urlPublicWebsite = environment.urlPublicWwebsite;
    this.groupedRoutes = [...this.routingService.getGroupedLeftMenu()];
  }

  subscription() {
    if (environment.authAppGuard === AppGuardType.NOT_AUTHENTICATED_JUST_LOGGEDIN) {
      this.loggedInService.fullyLoggedInState$.subscribe(
        (isFullyLoggedIn: FullyLoggedInStateType) => {
          if (isFullyLoggedIn === FullyLoggedInStateType.SUCCESS) {
            this.setMenu();
          }
        }
      );
    } else {
      this.setMenu();
    }
  }

  fixMenu() {
    this.enableAutoCollapse = !this.enableAutoCollapse;
    this.autoCollapseChange.emit(this.enableAutoCollapse);
  }
}
